export default __webpack_public_path__ + "static/media/ic_tooltip.bb0283fb.svg";